export const GATEWAY_MOBILE_TRANSFER = '30';
export const GATEWAY_ATM = '31';
export const GATEWAY_MERCHANT = '32';
export const GATEWAY_INVOICE_POSTPAID = '33';
export const GATEWAY_INVOICE_PREPAID = '34';
export const GATEWAY_TOP_UP = '35';
export const GATEWAY_BANK_TRANSFER = '36';
export const GATEWAY_PREPAID_CARD = '37';
